import React from 'react';

import { Link } from 'react-router-dom';

import { Container } from './styleMenu';

function SubMenus() {
  return (
    <Container>
      <Link to="/menu-sub/register" className="link">
        Cadastrar Sub Menu
      </Link>
      <Link to="/menu-sub/list" className="link">
        Listar Sub Menu
      </Link>
    </Container>
  );
}

export default SubMenus;
